import { apiClient } from './api/apiClient';
import { API_ENDPOINTS } from '../config';

export interface CollectionStat {
  key: string;
  label: string;
  count: number;
  newThisMonth: number;
}

export interface DayActivity {
  date: string;
  day: string;
  count: number;
}

export interface EndpointStat {
  path: string;
  count: number;
  avgMs: number;
}

export interface RecentLog {
  method: string;
  path: string;
  statusCode: number;
  responseTime: number;
  ip: string;
  createdAt: string;
}

export interface StatusBucket {
  label: string;
  count: number;
  rate: number;
  color: string;
}

export interface DashboardStats {
  collections: CollectionStat[];
  weeklyActivity: DayActivity[];
  statusDistribution: StatusBucket[];
  topEndpoints: EndpointStat[];
  recentLogs: RecentLog[];
  totalRequests: number;
  totalRequestsToday: number;
}

class DashboardService {
  async getStats(): Promise<DashboardStats | null> {
    const res = await apiClient.get<DashboardStats>(API_ENDPOINTS.ANALYTICS_DASHBOARD, true);
    if (res.statusCode === 200 && res.data) return res.data;
    return null;
  }
}

export default new DashboardService();
